import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { InboxCommonPayment } from 'pages/settings/ui/InboxCommonPayment/InboxCommonPayment'
import { useBuyNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'

export const Payment = observer(() => {
  const {
    paymentStore,
    buyNumber,
    selectedNumbersCount,
    loading,
    chooseNumberStore: { chooseNumberTabsStore },
    setVisibleUI,
  } = useBuyNumberStepsContext()

  useEffect(() => {
    setVisibleUI(true)

    return () => {
      setVisibleUI(false)
    }
  }, [])

  return (
    <InboxCommonPayment
      isBuyingNumber
      salesmsgNumbers={[]}
      licensesRequired={selectedNumbersCount}
      stepLoading={loading}
      paymentStore={paymentStore}
      chooseNumberTabsStore={chooseNumberTabsStore}
      handleOnClick={() => buyNumber()}
      buttonText={'Buy number'}
    />
  )
})
